import { FdsIconType } from '@tcc/fds';
import { UserRole } from '../../types/user';
import { FeatureAsset } from '../../types/assets';
import { ImpersonationMode } from '../../types/impersonationModes';

export enum NavigationItemType {
  LINK = 'link',
  MENU = 'menu',
}
export interface LinkDescriptor {
  id?: string;
  label: string;
  href: string;
  testId?: string;
  queryParams?: Record<string, string>;
  allowedRoles?: UserRole[];
  excludedRoles?: UserRole[];
  allowedContryCodes?: string[];
  excludedContryCodes?: string[];
  allowedFeatureAssets?: FeatureAsset[];
  requiredFeatureFlags?: string[];
  excludedByFeatureFlag?: string[];
  allowedImpersonationModes?: ImpersonationMode[];
  excludedImpersonationModes?: ImpersonationMode[];
  isActiveRegexs?: RegExp[];
  leadingIcon?: FdsIconType;
  trailingIcon?: FdsIconType;
  activity?: boolean;
  notificationBadge?: string;
  order?: number;
}

export interface MenuDescriptor {
  id: string,
  label: string;
  leadingIcon?: FdsIconType;
  trailingIcon?: FdsIconType;
  links: LinkDescriptor[];
  order?: number;
}

export enum UrlPlaceholders {
  ROOT_URL = '{{ROOT_URL}}',
  QUERY_PARAMS = '{{QUERY_PARAMS}}',
  EXPERTO_URL = 'https://experto.climate.com'
}
export interface NavigationLink {
  id?: string;
  label: string;
  href: string;
  testId?: string;
  isActive: boolean;
  order?: number;
}
export interface NavigationMenu {
  id: string,
  label: string;
  leadingIcon?: FdsIconType;
  trailingIcon?: FdsIconType;
  links: NavigationLink[];
  order?: number;
}

export interface NavigationItem {
  id?: string;
  type: NavigationItemType;
  order?: number;
  data: NavigationLink | NavigationMenu | undefined;
}

